import { OrderTermId, OrderTermResponse } from '@business/entities/order';
import { Endpoint } from '../endpoint';

export function fetchTerms() {
  return Endpoint.get<OrderTermResponse[]>(`@gc/terms`);
}

export function fetchTerm(id: OrderTermId) {
  return Endpoint.get<OrderTermResponse>(`@gc/terms/stage/${id}`);
}

export function createTerm(data: Partial<OrderTermResponse>) {
  return Endpoint.post<OrderTermResponse>(`@gc/terms`, { data });
}

export function updateTerm(id: OrderTermId, data: Partial<OrderTermResponse>) {
  return Endpoint.patch<OrderTermResponse>(`@gc/terms/${id}`, { data });
}

export function deleteTerm(id: OrderTermId) {
  return Endpoint.delete<void>(`@gc/terms/${id}`);
}
export function sync() {
  return Endpoint.get<OrderTermResponse[]>(`@gc/terms/sync`);
}
